import React from 'react';
import LiveSiteHeader from 'react/layout/header/LiveSiteHeader';
import { setHeaderPath } from 'react/layout/header/siteHeaderState';
import { hydrateIntoContainer, renderIntoContainer } from 'react/root/containerRoot';

// Mounts the site header on the root views/web/layout/flatlab.php prints. The
// props sit in the script after it (services\layout\SiteHeaderProps);
// data-server-rendered means the root already holds the ssr service's HTML.
// Without it (the ssr service was down) the header renders synchronously, so
// scripts that run after this one find it in place. The header stays mounted
// across client navigation and marks the new page's section as soon as the
// navigation starts, then again where it landed (a redirect may move it).
// Returns false on pages without the root.
export default function mountSiteHeader(rootDocument = document) {
	const root = rootDocument.getElementById('site_header_root');
	if(!root) {
		return false;
	}
	const header = JSON.parse(rootDocument.getElementById(`${root.id}-props`).textContent);
	const element = <LiveSiteHeader header={header} />;
	if(root.hasAttribute('data-server-rendered')) {
		hydrateIntoContainer(element, root);
	}
	else {
		renderIntoContainer(element, root);
	}
	const followNavigation = (event) => {
		setHeaderPath(new URL(event.detail.url).pathname);
	};
	rootDocument.defaultView.addEventListener('smashladder:navigating', followNavigation);
	rootDocument.defaultView.addEventListener('smashladder:navigated', followNavigation);
	return true;
}
